import angular from 'angular';
import template from './template.html';
import { VIEW_STATE } from '../../../summernote-options';
import { MessageTextArea } from '../message';
import './style.scss';

export class EmailTextArea extends MessageTextArea {
    originalEmail = {};

    internalEmail = {};

    $onChanges() {
        this.internalEmail = angular.copy(this.email);
        this.originalEmail = angular.copy(this.internalEmail);
        this.setState(this.textareaState);
    }

    onSaveMessage() {
        this.onEmailChange({ email: this.internalEmail });
        this.setState(VIEW_STATE);
    }

    onCancelEditMessage() {
        this.internalEmail = angular.copy(this.originalEmail);

        this.setState(VIEW_STATE);
    }
}

export const messageTextAreaConfiguration = {
    template,
    bindings: {
        email: '<',
        textareaState: '<',
        onEmailChange: '&',
        onEditStateChange: '&',
    },
    controller: EmailTextArea,
    controllerAs: 'emailTextAreaCtrl',
};

angular.module('TALENYA-FE').component('emailTextarea', messageTextAreaConfiguration);